export type HubspotConsent = {
  analytics?: boolean;
  advertisement?: boolean;
  functionality?: boolean;
};

export const getHubspotConsent = (): HubspotConsent | null => {
  const match = document.cookie.match(/__hs_cookie_cat_pref=([^;]+)/);
  if (!match) return null;

  const value = decodeURIComponent(match[1]);
  const parts = value.split(',');
  const map: Record<string, boolean> = {};

  parts.forEach((part) => {
    const [key, val] = part.split(':');
    map[key] = val === 'true';
  });

  return {
    analytics: map['1'],
    advertisement: map['2'],
    functionality: map['3'],
  };
};
